export interface ILookupDef {
    tableName: string;
    title: string;
    indexPath: string;
    editorComponentName?: string;
    tableColumns?: DataTables.ColumnSettings[];
}

export class LookupDefs {

    static lookupDefs: ILookupDef[] =
    [
        { tableName: "ConnectionType", title: "Connection Types", indexPath: "/connectiontypes" },
        { tableName: "Brand", title: "Tool Types", indexPath: "/brands" },
        { tableName: "StatorFit", title: "Stator Fits", indexPath: "/statorfits" },
        { tableName: "PipeClass", title: "Pipe Classes", indexPath: "/pipeclasses" },
        { tableName: "ProvinceState", title: "Provinces/States", indexPath: "/provincestates" },
        { tableName: "Country", title: "Countries", indexPath: "/countries" },
        { tableName: "ProductType", title: "Product Types", indexPath: "/producttypes" },
        //{ tableName: "EquipmentClass", title: "Equipment Classes", indexPath: "/equipmentclasses" }, // Not a simple lookup, has its own route
        { tableName: "EquipmentType", title: "Equipment Types", indexPath: "/equipmenttypes" }, // Not a simple lookup, has its own route
        { tableName: "EquipmentStatus", title: "Equipment Status", indexPath: "/equipmentstatus" },
        { tableName: "ShippingStatus", title: "Shipping Status", indexPath: "/shippingstatus" },
        { tableName: "FinancialStatus", title: "Financial Status", indexPath: "/financialstatus" },
        { tableName: "DeliveryTicketStatus", title: "Delivery Ticket Status", indexPath: "/deliveryticketstatus" },
        {
            tableName: "DeliveryTicketDetailsStatus",
            title: "Delivery Ticket Details Status",
            indexPath: "/deliveryticketdetailsstatus"
        },
        { tableName: "ReworkType", title: "Rework Types", indexPath: "/reworktypes" },
        { tableName: "EventType", title: "Event Types", indexPath: "/eventtype" },
        { tableName: "LengthUnit", title: "Length Units", indexPath: "/lengthunits" },
        { tableName: "Mud", title: "Mud", indexPath: "/muds" },
        { tableName: "RotorType", title: "Rotor Types", indexPath: "/rotortypes" },
        { tableName: "WeightUnit", title: "Weight Units", indexPath: "/weightunits" },
        { tableName: "Area", title: "Areas", indexPath: "/areas" },
        { tableName: "BallSeat", title: "Ball Seats", indexPath: "/ballseats" },
        { tableName: "BypassPort", title: "Bypass Ports", indexPath: "/bypassports" },
        { tableName: "Freight", title: "Freight", indexPath: "/freights" },
        {
            tableName: "Location", title: "Locations", indexPath: "/locations",
            editorComponentName: "location-editor",
            tableColumns: [
                {
                    name: "value",
                    data: "value",
                    title: "Location"
                },
                {
                    name: "applyUsage",
                    data: "applyUsage",
                    title: "Apply Usage"
                }
                ]
        },
        { tableName: "Range", title: "Ranges", indexPath: "/ranges" },
        { tableName: "ElastomerType", title: "Elastomer Types", indexPath: "/elastomertypes" },
        { tableName: "StatorCondition", title: "Stator Conditions", indexPath: "/statorconditions" },
        { tableName: "EquipmentSeries", title: "Series", indexPath: "/series" },
        {
            tableName: "Rig", title: "Rigs", indexPath: "/rigs", editorComponentName: "rig-editor",
            tableColumns: [
                {
                    name: "value",
                    data: "value",
                    title: "Rig Name"
                },
            {
                name: "description",
                data: "description",
                title: "Rig Size"
                },
            {
                    name: "companyName",
                    data: "companyName",
                    title: "Company"
                }]

        },
        {
            tableName: "Size", title: "Sizes", indexPath: "/sizes", editorComponentName: "size-editor",
            tableColumns: [
                {
                    name: "value",
                    data: "value",
                    title: "Value"
                },
                {
                    data: "inchesName",
                    title: "Inches Name"
                },
                {
                    data: "inchesDecimal",
                    title: "Inches Decimal"
                },
                {
                    data: "millName",
                    title: "Mill Name"
                }]
        },
        {
            tableName: "ValveType", title: "Valve Types", indexPath: "/valvetypes",
            editorComponentName: "valve-type-editor",
            tableColumns: [
                {
                    name: "value",
                    data: "value",
                    title: "Value"
                },
                {
                    data: "numByPassPorts",
                    title: "Bypass Ports"
                },
                {
                    data: "isEnabled",
                    title: "Enabled"
                }]

            },
        {
            tableName: "NumberControl", title: "Number Control", indexPath: "/numbercontrol",
            editorComponentName: "number-control-editor",
            tableColumns: [
                {
                    data: "value",
                    title: "Name"
                },
                {
                    data: "nextNumber",
                    title: "Next Number"
                }]

            },
            { tableName: "FlagReason", title: "Flag Reasons", indexPath: "/flagreasons" }


    ].sort((item1, item2): number => {
        return item1.title > item2.title ? 1 : -1;
    })
}



// WEBPACK FOOTER //
// ./ClientApp/infrastructure/lookup-list.ts